import React from 'react';
import { Box, TableCell } from '@mui/material';
import Label from '../../components/label';
import { normalizeTagsValue } from '../../utils/formatName';

export default class GridTagsCell extends React.Component {
    render() {
        const { field, value } = this.props;
        const parsedValue = value ? normalizeTagsValue(value) : [];

        const visibleTags = parsedValue.slice(0, 2);

        const remainingCount = parsedValue.length - visibleTags.length;

        return (
            <TableCell key={field.id} align="left">
                <Box sx={{ display: 'flex', justifyContent: 'start', gap: 1 }}>
                    {visibleTags.map((tag, index) => (
                        <Label key={index} sx={{ fontWeight: '500' }}>
                            {tag}
                        </Label>
                    ))}
                    {remainingCount > 0 && (
                        <Label sx={{ fontWeight: '500' }}>
                            +{remainingCount}
                        </Label>
                    )}
                </Box>
            </TableCell>
        );
    }
}
